export const blockIconsTravelLocalBarNew = (
	<span className='material-symbols-outlined'>local_bar</span>
);
